export default __webpack_public_path__ + "static/AE_story-56ed92fb1da1ecb3b489e79255b8bcfa.png";